import {styled} from "@mui/material";

export const TitleContainer = styled('div')({
  paddingBottom: 10,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});
